import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	createErrorTitle: {
		id: 'eoc-heartbeats.services.store.create-heartbeat-error-title',
		defaultMessage: 'We couldn’t create the heartbeat',
		description: `This message will be shown when the request for creating the heartbeat fails and it will be shown
    on the error flag title`,
	},
	editErrorTitle: {
		id: 'eoc-heartbeats.services.store.edit-heartbeat-error-title',
		defaultMessage: 'We couldn’t edit the heartbeat',
		description: `This message will be shown when the request for editing the heartbeat fails and it will be shown
    on the error flag title`,
	},
	deleteErrorTitle: {
		id: 'eoc-heartbeats.services.store.delete-heartbeat-error-title',
		defaultMessage: 'We couldn’t delete the heartbeat',
		description: `This message will be shown when the request for deleting the heartbeat fails and it will be shown
    on the error flag title`,
	},
	deleteSuccessTitle: {
		id: 'eoc-heartbeats.services.store.delete-heartbeat-success-title',
		defaultMessage: 'Heartbeat {heartbeatName} is deleted',
		description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag title`,
	},
	deleteSuccessDescription: {
		id: 'eoc-heartbeats.services.store.delete-heartbeat-success-description',
		defaultMessage: "We'll no longer monitor the sender system and send alerts for this",
		description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag description`,
	},
	switchSuccessTitle: {
		id: 'eoc-heartbeats.services.store.switch-heartbeat-success-title',
		defaultMessage: 'Heartbeat {enable, select, true {turned on} other {turned off}} successfully.',
		description: `This message will be shown when the request for turning the heartbeat on/off succeeded and it will be shown
    on the success flag title`,
	},
	switchErrorTitle: {
		id: 'eoc-heartbeats.services.store.switch-heartbeat-error-title',
		defaultMessage: "We couldn't {enable, select, true {turn on} other {turn off}} the heartbeat.",
		description: `This message will be shown when the request for turn on/off the heartbeat fails and it will be shown
    on the error flag title`,
	},
});

export default messages;
